export default "afa2be2765581a3c.svg"